// Firebase Web SDK initialization for Pub Golf.
//
// Project: pub-golf-489812
// Get the apiKey + appId from Firebase Console:
//   Project Settings → General → Your apps → Web app → SDK setup and configuration
//
// In Firebase Console, also confirm:
//   1. Authentication → Sign-in method → Google is ENABLED
//   2. Authentication → Settings → Authorized domains includes:
//      - localhost
//      - pubgolfgame.com
//      - pub-golf-489812.firebaseapp.com (default, already there)

import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    'pub-golf-489812.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'pub-golf-489812',
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseEnabled = Boolean(firebaseConfig.apiKey);

// Avoid double-init when Vite HMR re-runs the module.
const app =
  firebaseEnabled && (getApps()[0] || initializeApp(firebaseConfig)) || null;

export const auth = app ? getAuth(app) : null;
export const googleProvider = (() => {
  if (!app) return null;
  const p = new GoogleAuthProvider();
  // Always show the account chooser so users can switch accounts.
  p.setCustomParameters({ prompt: 'select_account' });
  return p;
})();
